import { ReactElement } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import type { OrganisationDTO } from '@api/fastAPI.schemas'
import IsAdminCheckboxField from '../../../IsAdminCheckboxField'
import OrganisationAutocompleteField from '../../../OrganisationAutocompleteField'
import type { AddMembershipFormValues } from '../../types'

interface AddMembershipFieldsProps {
  joinableOrganisations: OrganisationDTO[]
}

const AddMembershipFields = ({ joinableOrganisations }: AddMembershipFieldsProps): ReactElement => {
  const { control } = useFormContext<AddMembershipFormValues>()
  const {
    field: { value: organisationValue, onChange: onOrganisationChange },
  } = useController({ name: 'organisation', control })
  const {
    field: { value: isAdminValue, onChange: onIsAdminChange },
  } = useController({ name: 'isAdmin', control })

  return (
    <>
      <OrganisationAutocompleteField
        sx={{ flexGrow: 1 }}
        organisations={joinableOrganisations}
        value={organisationValue}
        onChange={onOrganisationChange}
        dataCy="select-organisation"
        noOptionsText="Keine weitere Organisation"
      />
      <IsAdminCheckboxField
        value={isAdminValue}
        onChange={onIsAdminChange}
        label="Admin"
        dataCy="checkbox-add-as-admin"
      />
    </>
  )
}

export default AddMembershipFields
